export function formatTinNo(inputtedValue) {
  const stringValue = String(inputtedValue ?? "");

  const digitsOnly = stringValue.replace(/\D/g, "").substring(0, 14);

  if (digitsOnly.length === 0) return "";

  let formatted = digitsOnly;

  if (digitsOnly.length > 3 && digitsOnly.length <= 6) {
    formatted = `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(3)}`;
  } else if (digitsOnly.length > 6 && digitsOnly.length <= 9) {
    formatted = `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(
      3,
      6,
    )}-${digitsOnly.slice(6)}`;
  } else if (digitsOnly.length > 9) {
    formatted = `${digitsOnly.slice(0, 3)}-${digitsOnly.slice(
      3,
      6,
    )}-${digitsOnly.slice(6, 9)}-${digitsOnly.slice(9)}`;
  }

  return formatted;
}
